import React from "react";
import { useNavigate } from "react-router-dom";
import { Play } from "lucide-react";
import { imgUrl } from "../lib/api";

export const SeriesCard = ({ series, index = 0 }) => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(`/series/${series.id}`)}
      data-testid={`series-card-${series.id}`}
      style={{ animationDelay: `${index * 60}ms` }}
      className="group relative shrink-0 w-40 sm:w-48 md:w-52 snap-start text-left animate-fade-up"
    >
      <div className="relative aspect-[2/3] overflow-hidden rounded-lg bg-[#0A0A0A] border border-white/5 group-hover:border-blood/60 transition-all duration-300 group-hover:shadow-[0_0_24px_rgba(220,20,60,0.25)]">
        {series.poster_url ? (
          <img
            src={imgUrl(series.poster_url)}
            alt={series.title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-white/20 font-display font-bold text-center px-3">
            {series.title}
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="flex items-center gap-2 text-xs font-bold text-white">
            <Play size={16} className="fill-blood text-blood" /> View Series
          </span>
        </div>
      </div>
      <p className="mt-2 text-sm font-semibold text-white/90 truncate group-hover:text-blood transition-colors">
        {series.title}
      </p>
      {series.genres?.length > 0 && (
        <p className="text-[11px] text-white/40 truncate">{series.genres.join(" · ")}</p>
      )}
    </button>
  );
};
